<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="800">
    <template v-slot:title>Edit Linked Service</template>
    <v-row>
      <v-col>
        <v-select
          v-model="sourceServiceId"
          :items="supplierServices"
          label="Source Service"
          hide-details
          dense
          :outlined="outlinedInputs"
          item-text="name"
          item-value="id"
        />
      </v-col>
      <v-col>
        <agent-group-select
          v-model="groupId"
          :outlined="outlinedInputs"
          hide-details
          dense
          label="Agent Group"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <supplier-list-select-by-type
          v-model="targetSupplierId"
          :supplier-type="targetSupplierServiceType"
          :outlined="outlinedInputs"
          hide-details
          dense
          label="Target Supplier"
        />
      </v-col>
      <v-col>
        <v-select
          v-model="targetServiceId"
          :items="targetServices"
          label="Target Service"
          hide-details
          dense
          :outlined="outlinedInputs"
          item-text="name"
          item-value="id"
          :disabled="$apollo.loading"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <dates-range-picker
          :gt-date-from-string="dateFrom"
          :gt-date-to-string="dateTo"
          :outlined="outlinedInputs"
          @onRangeSelected="onDatesChange"
          hide-details
          dense
          :disabled="!useDateRange"
        ></dates-range-picker>
      </v-col>
      <v-col class="pt-0">
        <v-switch
          v-model="useDateRange"
          label="Use Date Range"
          hide-details
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3" class="py-0">
        <v-switch
          v-model="isMandatory"
          label="Is Mandatory"
          hide-details
          dense
        />
      </v-col>
      <v-col cols="3" class="py-0">
        <v-switch v-model="notInUse" label="Not In Use" hide-details dense />
      </v-col>
    </v-row>
    <v-row v-if="debug">
      <v-col>
        <code>{{ targetSupplierId }}</code>
        <code>{{ targetSupplierServiceType }}</code>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave">Save</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../../helpers";
import AgentGroupSelect from "../../shared/AgentGroupSelect.vue";
import BasicDialog from "../../shared/BasicDialog";
import SupplierListSelectByType from "../../shared/SupplierListSelectByType.vue";
import DatesRangePicker from "../../shared/DatesRangePicker.vue";
const TARGET_SUPPLIER_SERVICES = gql`
  query targetSupplierServices($id: ID!) {
    targetSupplier: supplier(id: $id) {
      id
      services(filter: { not_in_use_eq: false }) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`;
export default {
  name: "edit-linked-service-dialog",
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
    services: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    BasicDialog,
    AgentGroupSelect,
    SupplierListSelectByType,
    DatesRangePicker,
  },
  data() {
    return {
      debug: false,
      sourceServiceId: this.value ? this.value.sourceServiceId : "",
      targetSupplierId: this.value ? this.value.targetSupplierId : "",
      targetSupplierServiceType: this.value
        ? this.value.targetSupplierServiceType
        : "ACCOMMODATION",
      targetServiceId: this.value ? this.value.targetServiceId : "",
      groupId: this.value ? this.value.groupId : "",
      dateFrom: this.value ? this.value.dateFrom : "",
      dateTo: this.value ? this.value.dateTo : "",
      notInUse: this.value ? this.value.notInUse : false,
      isMandatory: this.value ? this.value.isMandatory : false,
      useDateRange: this.value
        ? this.value.dateFrom != "" && this.value.dateTo != ""
        : false,
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    supplierServices() {
      return this.services.map(removeGQLTypename);
    },
    targetServices() {
      return this.targetSupplier
        ? this.targetSupplier.services.edges.map(removeGQLTypename)
        : [];
    },
  },

  watch: {
    value(newVal) {
      this.sourceServiceId = newVal ? newVal.sourceServiceId : null;
      this.targetServiceId = newVal ? newVal.targetServiceId : null;
      this.groupId = newVal ? newVal.groupId : null;
      this.dateFrom = newVal ? newVal.dateFrom : null;
      this.dateTo = newVal ? newVal.dateTo : null;
      this.notInUse = newVal ? newVal.notInUse : false;
      this.isMandatory = newVal ? newVal.isMandatory : false;
      this.targetSupplierServiceType = newVal
        ? newVal.targetSupplierServiceType
        : "ACCOMMODATION";
      this.targetSupplierId = newVal ? newVal.targetSupplierId : null;
      this.useDateRange = newVal
        ? newVal.dateFrom != "" && newVal.dateTo != ""
        : false;
    },
  },

  methods: {
    onDatesChange(dates) {
      this.dateFrom = dates.dateFrom;
      this.dateTo = dates.dateTo;
    },
    onSave() {
      this.$emit("save", {
        id: this.value ? this.value.id : null,
        sourceServiceId: this.sourceServiceId,
        targetServiceId: this.targetServiceId,
        groupId: this.groupId,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        notInUse: this.notInUse,
        isMandatory: this.isMandatory,
      });
    },
  },
  apollo: {
    targetSupplier: {
      query: TARGET_SUPPLIER_SERVICES,
      variables() {
        return { id: this.targetSupplierId };
      },
      skip() {
        return this.targetSupplierId == "";
      },
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/suppliers/linked-services/EditLinkedServiceDialog.vue